/* eslint-disable react/react-in-jsx-scope */
/*
 *
 * Copyright © Tessell Inc, 2021. All rights reserved.
 *
 *     Date               Author                  Comment
 *   --------------------------------------------------
 *     12/22/2021     bakul.banthia         Created
 *
 */

import clsx from 'clsx';
import { useStyles } from './utils';

export default function MilvusSmallIcon(props) {
    const { className } = props;
    const iconStyle = useStyles(props);

    return (
        <svg
            className={clsx({ [className]: !!className })}
            style={iconStyle}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.34709 3.12134C8.64289 3.14228 9.77739 3.58037 10.7238 4.4921C11.4821 5.22257 11.9495 6.11648 12.1355 7.16234C12.1867 7.44691 12.2099 7.73599 12.2048 8.02526C12.1817 9.20127 11.8017 10.242 11.0429 11.1314C10.3075 11.9934 9.38414 12.5405 8.28342 12.7466C6.79891 13.0244 5.45207 12.6868 4.25993 11.7356C4.01228 11.5381 3.7974 11.304 3.57347 11.0803C3.09139 10.5986 2.60987 10.1164 2.12893 9.63355C1.69265 9.1968 1.25628 8.76016 0.819809 8.32361C0.617143 8.12012 0.616999 7.83777 0.819559 7.6343C1.26782 7.18401 1.71685 6.73451 2.16666 6.28582C2.58897 5.86346 3.00919 5.43887 3.43477 5.01994C3.71731 4.74182 3.98469 4.44716 4.29461 4.19841C4.91211 3.70277 5.60611 3.37664 6.37658 3.22C6.69607 3.1544 7.02118 3.12135 7.34709 3.12134ZM11.0926 7.98272C11.0876 7.77158 11.0706 7.56443 11.0322 7.35938C10.8433 6.35062 10.3231 5.56274 9.48167 5.00547C8.67018 4.46799 7.77831 4.30096 6.82711 4.48442C6.14273 4.61642 5.54603 4.92967 5.04222 5.41987C4.70908 5.74402 4.38253 6.0752 4.05358 6.4038C3.61259 6.84431 3.17198 7.28521 2.73176 7.72651C2.5797 7.87924 2.58035 8.07881 2.73125 8.23085C2.94727 8.44852 3.16483 8.6646 3.3815 8.88161C3.90975 9.41065 4.43799 9.93971 4.96624 10.4688C5.73218 11.233 6.65101 11.5902 7.72272 11.5403C8.28958 11.5136 8.82409 11.3596 9.31118 11.0641C10.4562 10.3695 11.041 9.33422 11.0926 7.98272ZM13.454 7.97961C13.4547 7.44898 13.4031 6.92353 13.2881 6.40525C13.2846 6.38948 13.2819 6.37353 13.28 6.35748C13.2741 6.3089 13.2905 6.27037 13.3317 6.24399C13.3744 6.21653 13.418 6.21527 13.4599 6.24488C13.4772 6.25835 13.4933 6.27336 13.5081 6.28972C13.9448 6.73441 14.3814 7.17917 14.818 7.62401C15.0332 7.84324 15.0328 8.12238 14.8171 8.3421C14.3819 8.78546 13.9466 9.22881 13.5114 9.67216C13.5002 9.6836 13.4892 9.69537 13.4776 9.70633C13.4346 9.74675 13.3856 9.755 13.3356 9.72451C13.2891 9.69615 13.2685 9.65356 13.2808 9.59581C13.3267 9.38078 13.3661 9.16459 13.3943 8.94624C13.4277 8.68761 13.4498 8.42824 13.4538 8.16737C13.4548 8.10481 13.454 8.0422 13.454 7.97961Z"
                fill="#33B5F1"
            />
            <path
                d="M10.1633 7.97972C10.1604 9.30807 9.10534 10.396 7.75659 10.4177C6.35587 10.4404 5.31052 9.33004 5.26785 8.06963C5.22106 6.68758 6.32749 5.57442 7.6597 5.54615C9.00213 5.51766 10.1559 6.5818 10.1633 7.97972Z"
                fill="#33B5F1"
            />
        </svg>
    );
}

